<div class="confirm rounded-lg">
  <button mat-icon-button class="close-button" (click)="closeAll()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="confirm__container rounded-lg">
  @if (state.rescheduleMutation.result$ | async; as mutation) {
    @if (mutation.isPending) {
      <app-horus-loading></app-horus-loading>
    } @else if (mutation.isSuccess) {
      <app-horus-message-general
        nameIcon="successMessageIcon"
        btnAction="ACEPTAR"
        size="M"
        (action)="closeAll()">
        <p class="title-ok">¡Listo!</p>
        Reprogramaste la entrega del pedido de manera correcta.
      </app-horus-message-general>
    } @else if (state.isBusinessRuleError()) {
      <app-horus-message-general
        nameIcon="noDataMessageIcon"
        btnCancel="CANCELAR"
        btnAction="INGRESAR TICKET"
        size="L"
        (actionCancel)="closeAll()"
        (action)="redirectToAria()">
        <span style="color:#F6D44D; font-size: 14px; line-height: 25px;">No podemos ejecutar la acción</span><br>
        <span style="font-weight: 400;">Este pedido ya no puede ser reprogramado. Si aún deseas continuar con este proceso, ingresa un ticket.</span>
      </app-horus-message-general>
    } @else if (state.isGeneralMutationError()) {
      <app-horus-message-general
        nameIcon="errorMessageIcon"
        btnCancel="CANCELAR"
        btnAction="INTENTAR NUEVAMENTE"
        size="L"
        (actionCancel)="closeAll()"
        (action)="retry()">
        <span style="color:#F14B26; font-size: 14px; line-height: 25px;">Lo sentimos</span><br>
        Hubo un error al intentar reprogramar la entrega del pedido.
      </app-horus-message-general>
    } @else {
    <div class="confirm__body">
          <div class="confirm__body__icon">
            <mat-icon svgIcon="iconCalendar"></mat-icon>
          </div>
          <div class="confirm__body__message">
            <span>Estás a punto de reprogramar la entrega de este pedido a</span>
            <span class="confirm__body__message__date">
              <mat-icon>calendar_today</mat-icon>
              {{ payload.deliveryDate | availableDatePipe }}
            </span>
            <span>¿Quieres confirmar la <strong>reprogramación</strong>?</span>
          </div>
          <div class="confirm__body__actions">
            <button horusBtn horusBtnVariant="outline-default" horusBtnSize="md" class="w-full" (click)="close()">CANCELAR</button>
            <button horusBtn horusBtnSize="md" class="w-full" (click)="onConfirm()">CONFIRMAR</button>
          </div>
    </div>
    }
  }
</div>
